// Country-pack payment-tax rules (platform admin). These drive non-employee
// withholding across TZ/KE/RW. Statutory rates are platform-only; new rules
// start as drafts (review_required) and must be activated after a qualified tax
// professional confirms the rate. Talks to payroll-service via the gateway.
import axios from 'axios';

const API_V1 = (import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1').replace(
  /\/api(\/v1)?\/?$/,
  '/api/v1',
);
const BASE = `${API_V1}/payroll/platform/payment-tax-rules`;

function authHeader() {
  const token = localStorage.getItem('admin_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export interface PaymentTaxRule {
  id: string;
  code: string;
  country_code: string;
  payment_classification: string;
  worker_relationship: string;
  residency: string;
  recipient_legal_type: string;
  treatment: string;
  rate: string;
  finality: string;
  threshold: string;
  tax_code: string;
  filing_code: string;
  certificate_type: string;
  treaty_override_allowed: boolean;
  version: number;
  effective_from: string;
  effective_to: string;
  status: 'draft' | 'active' | 'retired';
  review_required: boolean;
  note: string;
}

export type CreateTaxRule = Omit<
  PaymentTaxRule,
  'id' | 'version' | 'status' | 'review_required'
>;

export async function listTaxRules(country?: string): Promise<PaymentTaxRule[]> {
  const { data } = await axios.get(BASE, { params: country ? { country } : {}, headers: { ...authHeader() } });
  return data.rules ?? [];
}

export async function createTaxRule(body: Partial<CreateTaxRule>): Promise<PaymentTaxRule> {
  const { data } = await axios.post(BASE, body, { headers: { ...authHeader() } });
  return data;
}

export async function retireTaxRule(id: string): Promise<PaymentTaxRule> {
  const { data } = await axios.post(`${BASE}/${id}/retire`, {}, { headers: { ...authHeader() } });
  return data;
}

export async function activateTaxRule(id: string): Promise<PaymentTaxRule> {
  const { data } = await axios.post(`${BASE}/${id}/activate`, {}, { headers: { ...authHeader() } });
  return data;
}
